export default __webpack_public_path__ + "static/media/forestly-expl-dissect-03_EN.7b36d97d.png";